/**
 * `#pricing` — `template.html` dòng 1012–1025. Thứ tự 3 gói là thứ tự thiết kế.
 *
 * `highlighted` và `badge` là TUỲ CHỌN nên mảng phải được gán kiểu `readonly PricingPlanCopy[]`.
 * Để `as const` thay thế thì mỗi phần tử thành một kiểu literal riêng, `plans.map()` trả về union,
 * và đọc `plan.badge` là lỗi biên dịch ở hai phần tử không khai khoá đó — đúng cái bẫy `modules.ts`
 * đã ghi lại.
 *
 * Ba `price` KHÔNG phải số: thiết kế vẽ ô dashed "đang hoàn thiện" (design doc §13 nợ 3). Đó là
 * chủ ý, và vì vậy trang KHÔNG khai JSON-LD `Product`/`Offer` — khai schema giá mà không có giá
 * là tín hiệu rác. Đừng "sửa" cho có giá.
 */
interface PricingPlanCopy {
  readonly name: string;
  readonly blurb: string;
  readonly price: string;
  readonly features: string;
  readonly highlighted?: boolean;
  readonly badge?: string;
}

export const pricing = {
  eyebrow: 'Bảng giá',
  heading: 'Các gói đang được hoàn thiện.',
  lead: 'Trong lúc chờ, hãy trao đổi với chúng tôi — chúng tôi sẽ thiết kế bản chạy thử phù hợp với đội của bạn.',
  plans: [
    {
      name: 'Team',
      blurb: 'Đội nhỏ bắt đầu triển khai.',
      price: 'Giá sẽ công bố sau',
      features: 'Chat, Topic, Voice · Project Manager · Knowledge Base',
    },
    {
      name: 'Business',
      blurb: 'Doanh nghiệp đang mở rộng, nhiều dự án.',
      price: 'Giá sẽ công bố sau',
      features: 'Toàn bộ gói Team · AI Agents & Skills · Connectors · Wiki',
      highlighted: true,
      badge: 'PHỔ BIẾN',
    },
    {
      name: 'Enterprise',
      blurb: 'Tổ chức lớn và ngành có quy định chặt.',
      price: 'Liên hệ đội kinh doanh',
      features: 'On-premise · SSO & nhật ký · Chuyển đổi & đào tạo · SLA',
    },
  ] as readonly PricingPlanCopy[],
};
